import axios from 'axios';
import { URLS, HTTP_METHODS } from '../helpers/constants';

/**
 * Fetch data from APIs related to segment detail
 *
 * @author fris4874
 */
class SegmentDataProxy {
  static async getSegmentCodes(segmentType, vendor) {
    const url = URLS.GET_SEGMENT_CODES_URL;
    const config = {
      url,
      method: HTTP_METHODS.GET,
      params: {
        vendor,
        segmentType,
      }
    };

    const response = await axios(config);
    return response.data;
  }

  static async getSegmentDetails(segmentType, segmentCode, segmentVersion) {
    const url = URLS.SEGMENT_DETAILS_URL;
    const config = {
      url,
      method: HTTP_METHODS.GET,
      params: {
        segmentType,
        segmentCode,
        segmentVersion,
      }
    };

    const response = await axios(config);
    return response.data;
  }

  static async createSegmentDetail(data, isNewSegment) {
    const url = URLS.SEGMENT_DETAILS_URL;
    const config = {
      url,
      method: HTTP_METHODS.POST,
      params: { isNewSegment },
      data
    };

    const response = await axios(config);
    return response.data;
  }

  static async updateSegmentDetail(segmentType, segmentCode, data) {
    const url = URLS.SEGMENT_DETAILS_URL;
    const config = {
      url,
      method: HTTP_METHODS.PUT,
      params: {
        segmentType,
        segmentCode,
      },
      data,
    };

    const response = await axios(config);
    return response.data;
  }

  static async deleteSegmentDetail(segmentType, segmentCode, segmentVersion) {
    const url = URLS.SEGMENT_DETAILS_URL;
    const config = {
      url,
      method: HTTP_METHODS.DELETE,
      params: {
        segmentType,
        segmentCode,
        segmentVersion,
      }
    };

    const response = await axios(config);
    return response.data;
  }

  static async getSegmentVersions(segmentType, segmentCode) {
    const url = URLS.GET_SEGMENT_CODE_VERSIONS_URL;
    const config = {
      url,
      method: HTTP_METHODS.GET,
      params: { segmentType, segmentCode },
    };

    const response = await axios(config);
    return response.data;
  }

  static async getSegmentVendorMapping(vendors, status, effectiveDate, includeAllVendors = false) {
    const url = URLS.GET_SEGMENT_VENDOR_MAPPING_URL;
    const vendorsParam = Array.isArray(vendors) ? vendors.join(',') : vendors;

    const config = {
      url,
      method: HTTP_METHODS.GET,
      params: {
        vendors: vendorsParam,
        status,
        effectiveDate,
        includeAllVendors,
      }
    };

    const response = await axios(config);
    return response.data;
  }
}

export default SegmentDataProxy;
